module.exports = __webpack_public_path__ + "img/icon_eye.1cabb443.svg";